/* ============================================================
   ELEGANCE ANIMATIONS — Master Escala
   Scroll-triggered reveals + lazy image fade-in.
   ~2.6KB minimal, no dependencies.
   ============================================================ */

(function() {
  'use strict';

  // ---------- Scroll-triggered reveals ----------
  function initRevealObserver() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: mostrar todo
      document.querySelectorAll('[data-elegance-reveal]').forEach(function(el) {
        el.classList.add('elegance-in-view');
      });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('elegance-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -50px 0px'
    });

    document.querySelectorAll('[data-elegance-reveal]').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ---------- Lazy image fade-in ----------
  function initLazyImageFade() {
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    imgs.forEach(function(img) {
      if (img.complete) {
        img.classList.add('is-loaded');
      } else {
        img.addEventListener('load', function() {
          img.classList.add('is-loaded');
        }, { once: true });
        img.addEventListener('error', function() {
          img.classList.add('is-loaded'); // mostrar broken icon en vez de fade infinito
        }, { once: true });
      }
    });
  }

  // ---------- Marquee duplication (para infinite scroll seamless) ----------
  function initMarquee() {
    var marquees = document.querySelectorAll('[data-elegance-marquee]');
    marquees.forEach(function(m) {
      var track = m.querySelector('[data-marquee-track]');
      if (!track || track.dataset.duplicated === '1') return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.parentNode.appendChild(clone);
      track.dataset.duplicated = '1';
    });
  }

  // ---------- Boot ----------
  function init() {
    initRevealObserver();
    initLazyImageFade();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init en navegación AJAX (themes con section rendering)
  document.addEventListener('shopify:section:load', init);
})();
